import { Component } from 'react'
import { API } from 'aws-amplify'
//import { v4 as uuidv4 } from 'uuid'
import config from './Config'

const apiPath = config.apiGatewayAdmin.PATH

class AdminClient extends Component {
	getCompanies() {
		return API.post(apiPath, 'companies/list', {})
	}

	getAllBrokers() {
		return API.post(apiPath, 'companies/get-all-brokers', {})
	}

	getCompanyBrokers(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/get-company-brokers', {
			body: data
		})
	}

	getReturnRequests() {
		return API.post(apiPath, 'leads/return-requests', {})
	}

	exportLeads(companyId, product, brokerId, fromDate, toDate, columns) {
		const data = {
			companyId,
			product,
			brokerId,
			fromDate,
			toDate,
			columns
		}
		console.log(data)

		return API.post(apiPath, 'export/leads', {
			body: data
		})
	}

	getReturnRequestsPeriod(product, fromDate, toDate) {
		const data = {
			product,
			fromDate,
			toDate
		}
		console.log(data)

		return API.post(apiPath, 'leads/return-requests-period', {
			body: data
		})
	}

	getReturnRequestsBatch(keys) {
		const data = {
			keys
		}
		console.log(data)

		return API.post(apiPath, 'leads/return-requests-batch', {
			body: data
		})
	}

	// --- Do Not Contact (DNC) suppression list ---
	getDncList(days = 30) {
		return API.post(apiPath, 'dnc/list', {
			body: { days }
		})
	}

	searchDncLead(phone, email) {
		return API.post(apiPath, 'dnc/search-lead', {
			body: { phone, email }
		})
	}

	addToDnc(entry) {
		return API.post(apiPath, 'dnc/add', {
			body: entry
		})
	}

	removeFromDnc(id) {
		return API.post(apiPath, 'dnc/remove', {
			body: { id }
		})
	}

	addCompany(companyId, name, dailyCapsActive, replacementsActive, active, billingAccount, billingPeriod, billingMethod, vatRate, brokerDiary) {
        const data = {
			companyId,
			name,
			dailyCapsActive,
			replacementsActive,
			active,
			billingAccount,
			billingPeriod,
			billingMethod,
			vatRate,
			brokerDiary
		}
		console.log(data)

        return API.post(apiPath, 'companies/add', {
            body: data
        })
    }

    createCompanyTables(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/create-tables', {
			body: data
		})
	}

    updateCompany(companyId, dailyCapsActive, replacementsActive, active, billingAccount, billingPeriod, billingMethod, billingEmail, vatRate, brokerDiary, productsAvailable) {
        const data = {
			companyId,
			dailyCapsActive,
			replacementsActive,
			active,
			billingAccount,
			billingPeriod,
			billingMethod,
			billingEmail,
			vatRate,
			brokerDiary,
			productsAvailable
		}
		console.log(data)

        return API.post(apiPath, 'companies/update', {
            body: data
        })
    }

	getCompanyDetails(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/get', {
			body: data
		})
	}

	getAllocated(product) {
		const data = {
			product
		}
		return API.post(apiPath, 'leads/get-allocated', {
			body: data
		})
	}

	// getLeadsPeriod(product, fromDate, toDate) {
	// 	const data = {
	// 		product,
	// 		fromDate,
	// 		toDate
	// 	}
	// 	console.log(data)
	// 	return API.post(apiPath, 'leads/get-leads-period', {
	// 		body: data
	// 	})
	// }

	getAllLeadsPeriod(product, fromDate, toDate) {
		const data = {
			product,
			fromDate,
			toDate
		}
		console.log(data)
		
		return API.post(apiPath, 'leads/get-all-period', {
			body: data
		})
	}

	rejectReturnRequest(request) {
		const data = {
			request
		}
		return API.post(apiPath, 'leads/reject-request', {
			body: data
		})
	}

	rejectReturnRequestMultiple(requests) {
		const data = {
			requests
		}
		return API.post(apiPath, 'leads/reject-request-multiple', {
			body: data
		})
	}

	acceptReturnRequest(request, pricing, currentValue) {
		const data = {
			request,
			pricing,
			currentValue
		}
		return API.post(apiPath, 'leads/accept-request', {
			body: data
		})
	}

	acceptReturnRequestMultiple(requests) {
		const data = {
			requests
		}
		return API.post(apiPath, 'leads/accept-request-multiple', {
			body: data
		})
	}

	deleteLeadsMultiple(companyId, product, leads) {
		const data = {
			companyId,
			product,
			leads
		}
		console.log(data)

		return API.post(apiPath, 'leads/delete-multiple', {
			body: data
		})
	}

	deleteGeneralLeadsMultiple(companyId, leads) {
		const data = {
			companyId,
			leads
		}
		console.log(data)

		return API.post(apiPath, 'leads/delete-gen-multiple', {
			body: data
		})
	}

	getCampaigns() {
		return API.post(apiPath, 'campaigns/list', {})
	}

	addCampaign(name, product, target) {
        const data = {
			name,
			product,
			target
		}
		console.log(data)

        return API.post(apiPath, 'campaigns/add', {
            body: data
        })
    }

	updateCampaign(campaignId, name, target) {
        const data = {
			campaignId,
			name,
			target
		}
		console.log(data)

        return API.post(apiPath, 'campaigns/update', {
            body: data
        })
    }

	getDeliveries() {
		return API.post(apiPath, 'deliveries/list', {})
	}

	getBalanceDeliveries() {
		return API.post(apiPath, 'deliveries/list-balance', {})
	}

	getBalanceDeliveryPricing(companyId, product) {
		const data = {
			companyId,
			product
		}
		console.log(data)

		return API.post(apiPath, 'deliveries/get-pricing', {
			body: data
		})
	}

	addDelivery(companyId, companyName, campaignId, product, campaignName, leadPrice, allocation, active, usePricingTable = false, pricing = null, priority = false) {
		const data = {
			companyId,
			companyName,
			campaignId,
			product,
			campaignName,
			leadPrice,
			allocation,
			active,
			usePricingTable,
			pricing,
			priority
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/add', {
            body: data
        })
	}

	addBalanceDelivery(companyId, companyName, product, active, pricing) {
		const data = {
			companyId,
			companyName,
			product,
			active,
			pricing
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/add-balance', {
            body: data
        })
	}

	updateDelivery(companyId, product, leadPrice, allocation, leadbyteNumber, active, usePricingTable = false, pricing = null, priority = false) {
		const data = {
			companyId,
			product,
			leadPrice,
			allocation,
			leadbyteNumber,
			active,
			usePricingTable,
			pricing,
			priority
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/update', {
            body: data
        })
	}

	getEffectivePensionPricing(companyId, product) {
		const data = {
			companyId,
			product
		}
		console.log(data)

		return API.post(apiPath, 'deliveries/get-effective-pricing', {
			body: data
		})
	}

	updateBalanceDelivery(companyId, product, balance, active, pricing, reason, companyName, actor) {
		const data = {
			companyId,
			product,
			balance,
			active,
			pricing,
			reason,
			companyName,
			actor
		}
		console.log(data)

        return API.post(apiPath, 'deliveries/update-balance', {
            body: data
        })
	}

	getBalanceLedger(companyId, product) {
		return API.post(apiPath, 'deliveries/balance-ledger', {
			body: { companyId, product }
		})
	}

	getBalanceLedgerFeed(exclusiveStartKey, product) {
		return API.post(apiPath, 'deliveries/balance-ledger-feed', {
			body: { exclusiveStartKey, product: product || 'pensions' }
		})
	}

	getPayments() {
		return API.post(apiPath, 'payments/list', {})
	}

	addPayment(companyId, companyName, date, billingMethod, billingAccount, billingPeriod, vatRate, allocation, subtotal, total, status, notes) {
		const data = {
			companyId,
			companyName,
			date,
			billingMethod,
			billingAccount,
			billingPeriod,
			vatRate,
			allocation, 
			subtotal, 
			total,
			status,
			notes
		}
		console.log(data)

        return API.post(apiPath, 'payments/add', {
            body: data
        })
	}

	updatePayment(companyId, date, billingAccount, vatRate, allocation, subtotal, total, status, notes, reference, amountPaid) {
		const data = {
			companyId,
			date,
			billingAccount,
			vatRate,
			allocation, 
			subtotal, 
			total,
			status,
			notes,
			reference,
			amountPaid
		}
		console.log(data)

        return API.post(apiPath, 'payments/update', {
            body: data
        })
	}

	deletePayment(companyId, date) {
		const data = {
			companyId,
			date
		}
		console.log(data)

        return API.post(apiPath, 'payments/delete', {
            body: data
        })
	}

	getProfitabilityWeeks() {
		return API.post(apiPath, 'profitability/list', {})
	}

	addProfitabilityWeek(country, date, details, leads, revenue, cost, notes) {
		const data = {
			country,
			date,
			details,
			leads,
			revenue,
			cost, 
			notes
		}
		console.log('data: ', data)

        return API.post(apiPath, 'profitability/add', {
            body: data
        })
	}

	updateProfitabilityWeek(country, date, details, leads, revenue, cost, notes) {
		const data = {
			country,
			date,
			details,
			leads,
			revenue,
			cost, 
			notes
		}
		console.log(data)

        return API.post(apiPath, 'profitability/update', {
            body: data
        })
	}

	deleteProfitabilityWeek(country, date) {
		const data = {
			country,
			date
		}
		console.log(data)

        return API.post(apiPath, 'profitability/delete', {
            body: data
        })
	}

	listExpenses() {
		return API.post(apiPath, 'expenses/list', {})
	}

	listExpensesByMonth(month) {
		return API.post(apiPath, 'expenses/listByMonth', {
			body: { month }
		})
	}

	addExpense(payload) {
		return API.post(apiPath, 'expenses/add', {
			body: payload
		})
	}

	updateExpense(payload) {
		return API.post(apiPath, 'expenses/update', {
			body: payload
		})
	}

	deleteExpense(month, id) {
		return API.post(apiPath, 'expenses/delete', {
			body: { month, id }
		})
	}

	copyExpensesFromMonth(fromMonth, toMonth) {
		return API.post(apiPath, 'expenses/copyMonth', {
			body: { fromMonth, toMonth }
		})
	}

	getLeads() {
		return API.post(apiPath, 'leads/list-all', {})
	}

	getLead(companyId, product, phone) {
		const data = {
			companyId,
			product,
			phone
		}
		console.log(data)

        return API.post(apiPath, 'leads/get', {
            body: data
        })
	}

	allocateLead(companyId, brokerId, lead, pricing) {
		const data = {
			companyId,
			brokerId,
			lead,
			pricing
		}
		console.log(data)

        return API.post(apiPath, 'leads/allocate', {
            body: data
        })
	}

	rejectLead(date, leadId) {
		const data = {
			date,
			leadId
		}
		console.log(data)

        return API.post(apiPath, 'leads/reject', {
            body: data
        })
	}

	rejectMultiple(leadIds) {
		const data = {
			leads: leadIds
		}
		console.log(data)

        return API.post(apiPath, 'leads/reject-multiple', {
            body: data
        })
	}

	getStartPensionApplications(companyId, fromDate, toDate) {
		const data = {
			companyId,
			fromDate,
			toDate
		}
		console.log(data)

        return API.post(apiPath, 'start-pension/list', {
			body: data
		})
	}

	getVerifiedSpApplicationsPeriod(companyId, fromDate, toDate) {
		const data = {
			companyId,
			fromDate,
			toDate
		}
		console.log(data)

        return API.post(apiPath, 'start-pension/list-verified-period', {
			body: data
		})
	}

	// getCompareInsuranceLeads() {
    //     return API.post(apiPath, 'compare-insurance/list', {})
	// }

	getCompareInsuranceLeads() {
		return API.post(apiPath, 'compare-insurance/list-all', {})
	}

	getCompareInsuranceLeadsPeriod(fromDate, toDate) {
		const data = {
			fromDate,
			toDate
		}
		console.log(data)
		return API.post(apiPath, 'compare-insurance/list-period', {
			body: data
		})
	}

	chargeCompany(payment) {
		const data = {
			payment
		}
		console.log(data)

        return API.post(apiPath, 'stripe/create-payment-intent', {
            body: data
        })
	}

	generateInvoice(payment, autoCharge = false) {
		const data = {
			payment,
			autoCharge
		}
		console.log(data)

        return API.post(apiPath, 'payments/generate-invoice', {
            body: data
        })
	}

	retryCharge(payment) {
		const data = {
			payment
		}
		console.log(data)

        return API.post(apiPath, 'payments/retry-charge', {
            body: data
        })
	}

	xeroSyncPreview(rows) {
		return API.post(apiPath, 'payments/xero-sync-preview', {
			body: { rows }
		})
	}

	xeroSync(rows) {
		return API.post(apiPath, 'payments/xero-sync', {
			body: { rows }
		})
	}

	sendPaymentLink(payment) {
		const data = {
			payment
		}
		console.log(data)

        return API.post(apiPath, 'payments/send-link', {
            body: data
        })
	}

	sendPaymentReminder(payment) {
		const data = {
			payment
		}
		console.log(data)

        return API.post(apiPath, 'payments/send-reminder', {
            body: data
        })
	}

	sendTopupLink(companyId, product, total) {
		const data = {
			companyId,
			product,
			total
		}
		console.log(data)

        return API.post(apiPath, 'payments/send-topup', {
            body: data
        })
	}

	// exchangeXeroCode(code) {
	// 	const data = {
	// 		code
	// 	}
	// 	console.log(data)

    //     return API.post(apiPath, 'payments/exchange-xero-code', {
    //         body: data
    //     })
	// }

	getValidationLists() {
        return API.post(apiPath, 'settings/get-validation-lists', {})
	}

	updateValidationList(list, items) {
		const data = {
			list,
			items
		}
		console.log(data)

        return API.post(apiPath, 'settings/update-validation-list', {
            body: data
        })
	}

	getProductsAvailable() {
        return API.post(apiPath, 'settings/get-products-available', {})
	}

	updateProductsAvailable(products) {
		const data = {
			products
		}
		console.log(data)

        return API.post(apiPath, 'settings/update-products-available', {
            body: data
        })
	}

	getActiveNPHBuyers() {
        return API.post(apiPath, 'nph/buyers', {})
	}

	getAllNPHLeads() {
		return API.post(apiPath, 'nph/leads', {})
	}

	getNPHLeadsPeriod(fromDate, toDate) {
		const data = {
			fromDate,
			toDate
		}
		return API.post(apiPath, 'nph/leads-period', {
			body: data
		})
	}

	updateLeadQuote(date, leadId, quote, employerSickPay) {
		const data = {
			date,
			leadId,
			quote,
			employerSickPay
		}
		console.log(data)

		return API.post(apiPath, 'leads/update-quote', {
			body: data
		})
	}

	updateLeadDetails(date, leadId, details) {
		const data = {
			date,
			leadId,
			details
		}
		console.log(data)

		return API.post(apiPath, 'leads/update-details', {
			body: data
		})
	}

	updateLeadNote(date, leadId, note) {
		const data = {
			date,
			leadId,
			note
		}
		console.log(data)

		return API.post(apiPath, 'leads/update-note', {
			body: data
		})
	}

	getLifeAllocationRules() {
        return API.post(apiPath, 'settings/get-life-allocation-rules', {})
    }

    updateLifeAllocationRules(rules) {
        const data = {
            rules
        }
        console.log(data)

        return API.post(apiPath, 'settings/update-life-allocation-rules', {
            body: data
        })
    }

    getIncomeProtectionAllocationRules() {
        return API.post(apiPath, 'settings/get-income-protection-allocation-rules', {})
    }

    updateIncomeProtectionAllocationRules(rules) {
        const data = {
            rules
        }
        console.log(data)

        return API.post(apiPath, 'settings/update-income-protection-allocation-rules', {
            body: data
        })
    }

    // FS Deliveries screen
    getFSDeliveries() {
        return API.post(apiPath, 'deliveries/list-fs-deliveries', {})
    }

    getFSLeadsPeriod(fromDate, toDate, product) {
        const data = {
            fromDate,
            toDate,
            product: product || null
        }
        return API.post(apiPath, 'deliveries/fs-leads-period', {
            body: data
        })
    }

    getStartPensionLeadsPeriod(fromDate, toDate) {
        return API.post(apiPath, 'deliveries/start-pension-leads-period', {
            body: { fromDate, toDate }
        })
    }
} 

export default AdminClient